var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('g', {
    attrs: {
      "fill": "currentColor",
      "transform": "translate(-310 -20)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M313.717 23.706c-.227 0-.411.19-.411.42v16.102c0 .232.19.42.419.42h16.133c.231 0 .42-.19.42-.413v-9.927c0-.29.227-.524.53-.524h.244c.293 0 .53.224.53.517v10.215c0 .776-.521 1.294-1.305 1.294h-16.971c-.784 0-1.306-.518-1.306-1.294v-16.81c0-.776.522-1.293 1.306-1.293h10.313c.288 0 .522.225.522.526v.241c0 .29-.226.526-.522.526h-9.902zm6.232 9.595l1.097-2.22 9.02-8.933c.202-.201.534-.187.72.012l.492.525c.195.208.19.538-.027.752l-9.015 8.898-2.287.966z"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }